import { Component, OnInit } from '@angular/core';
import { ApplicationService } from '../services/application.service'
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent implements OnInit {
  partnerName:string=''
  partnerType:string=''
  isAdmin:boolean=false;
  partnerTypeId:string='';
  constructor(private _applicationService: ApplicationService, private router: Router) {
    this.partnerName=this._applicationService.loginUserDetails.name;
    this.isAdmin=this._applicationService.loginUserDetails.isAdmin;
    this.partnerType=this._applicationService.loginUserDetails.partnertype;
    this.partnerTypeId = this._applicationService.loginUserDetails.partnertypeId;
  }

  ngOnInit() {

  }

  logoutUser() {   
    localStorage.removeItem('currentUser');               
    this.router.navigate(['login']);
  }
  

}
